<oui-dialog-content class="dialog-content">
  @if (isLoading()) {
    <div class="loading-container">
      <oui-loading></oui-loading>
    </div>
  } @else {
    <img
      class="dialog-image image-width"
      alt=""
      src="assets/images/signature_pending.svg" />

    <div class="headline-6">Renouvellement de votre collaboration</div>
    <span class="text-sm">
      Il est temps de nous indiquer si vous souhaitez continuer votre collaboration avec
      les sociétés Finzzle Groupe.
    </span>

    <div class="actions-container">
      <span class="body-2">
        <span class="warning-text">Réponse avant le 31 juillet jusqu'à minuit.</span>
        <br />
        Cette action est irréversible et ne peut pas être modifiée.
      </span>
      <div class="buttons-container">
        <oui-fat-button label="on continue ensemble" (click)="renouvellementAccept()"
          ><oui-icon class="icon-accept">check</oui-icon></oui-fat-button
        >
        <oui-fat-button label="je ne renouvelle pas" (click)="renouvellementRefuse()"
          ><oui-icon class="icon-refuse">close</oui-icon></oui-fat-button
        >
      </div>
    </div>

    <oui-banner
      declination="info"
      [showCloseButton]="false"
      [title]="bannerText"></oui-banner>

    <oui-button type="text" oui-dialog-close>Répondre plus tard</oui-button>
  }
</oui-dialog-content>
